import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { Address } from '../../address/Address'

@InputType()
export class ExtractOrderAddressesArgs extends ActionArgs {
  @Field(() => ID)
  orderId: string
}

export interface IExtractOrderAddresses extends IAction<Address[], ExtractOrderAddressesArgs> {}
